import React from 'react';
import html from '../assets/html.png';
import css from '../assets/css.png';
import github from '../assets/github.png';

import reactImage from '../assets/react.png';
import javascript from '../assets/javascript.png';

import node from '../assets/node.png';
import tailwind from '../assets/tailwind.png';
import { useTranslation } from 'react-i18next';

const Expirience = () => {
	const { t } = useTranslation('translation', {
		keyPrefix: 'expirience',
	});

	const techs = [
		{ id: 1, src: html, title: 'Html', style: 'shadow-orange-500' },
		{ id: 2, src: css, title: 'Css', style: 'shadow-blue-500' },
		{ id: 3, src: javascript, title: 'Javascript', style: 'shadow-yellow-500' },
		{ id: 4, src: reactImage, title: 'React', style: 'shadow-blue-600' },
		{ id: 5, src: tailwind, title: 'Tailwind', style: 'shadow-sky-400' },
		{ id: 8, src: github, title: 'Github', style: 'shadow-gray-400' },
		{ id: 9, src: node, title: 'Node', style: 'shadow-green-500' },
	];

	return (
		<section
			name='experience'
			className='bg-gradient-to-b from-gray-800 to-black w-full h-screen'
		>
			<div className='max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white'>
				<div>
					<p className='text-4xl font-bold inline border-b-4 border-gray-500 p-2'>
						{t('title')}
					</p>
					<p className='py-6'>{t('subTitle')}</p>
				</div>

				<div
					className='w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center 
        py-8 px-12 sm:px-0'
				>
					{techs.map(({ id, src, style, title }) => (
						<div
							key={id}
							className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style} `}
						>
							<img src={src} alt='' className='w-20 mx-auto' />
							<p className='mt-4'>{title}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Expirience;
